import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const CustomEventEmptyState = ({ height = 128, width = 128, ...props }: SvgIconProps) => (
  <SvgIcon height={height} width={width} data-test="custom-event-empty-state" {...props}>
    <path
      d="M14.726 76.16a51.199 51.199 0 0 0 87.404 36.204A51.2 51.2 0 1 0 14.726 76.16Z"
      fill={colors.grey5}
    />
    <path
      d="M40.525 27.195a3.15 3.15 0 0 1 2.355-2.363l4.736-1.092a.393.393 0 0 0 0-.768l-4.736-1.084a3.151 3.151 0 0 1-2.36-2.36l-1.09-4.735a.393.393 0 0 0-.769 0l-1.092 4.736a3.148 3.148 0 0 1-2.354 2.359L30.48 22.98a.393.393 0 0 0 0 .768l4.736 1.092a3.147 3.147 0 0 1 2.358 2.359l1.093 4.736a.393.393 0 0 0 .768 0l1.09-4.74ZM93.14 27.319l3.705-1.235a.348.348 0 0 0 0-.66L93.8 24.407a1.388 1.388 0 0 1-.88-.88l-1.016-3.048a.348.348 0 0 0-.66 0l-1.014 3.044a1.391 1.391 0 0 1-.88.88l-3.047 1.014a.348.348 0 0 0 0 .66l3.046 1.016a1.388 1.388 0 0 1 .88.88l1.014 3.046a.348.348 0 0 0 .661 0l1.237-3.701Z"
      fill={colors.mustard10}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.21 125.393c0 .521 1.45 1.022 4.032 1.391s6.084.576 9.736.576c3.652 0 7.154-.207 9.736-.576 2.583-.369 4.033-.87 4.033-1.391 0-.522-1.45-1.023-4.033-1.391-2.582-.369-6.084-.577-9.736-.577-3.652 0-7.154.208-9.736.577-2.582.368-4.033.869-4.033 1.391Z"
      fill={colors.grey15}
    />
    <path
      d="M41.073 120.401a1.507 1.507 0 0 0 1.237 1.737l7.357 1.234a1.317 1.317 0 0 0 1.184-.408 1.308 1.308 0 0 0 .302-1.215 4.524 4.524 0 0 0-3.632-3.328l-6.155-1.033-.293 3.013ZM34.01 125.037a1.306 1.306 0 0 0 1.102-.597 1.312 1.312 0 0 0 .097-1.249 4.521 4.521 0 0 0-4.132-2.678h-4.523a1.506 1.506 0 0 0-1.395.931 1.508 1.508 0 0 0-.115.577v1.508a1.508 1.508 0 0 0 1.51 1.508h7.457Z"
      fill={colors.cyan20}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M46.543 97.496H26.94l.128 15.733c.001.237-.025.474-.078.705l-2.285 5.575a1.31 1.31 0 0 0 1.217 1.808l8.09-.022a1.315 1.315 0 0 0 1.303-1.422l-.536-6.29.295-7.613a2.491 2.491 0 0 1 1.799-2.367 2.435 2.435 0 0 1 2.832 1.348l1.369 4.068c.43 1.278.51 2.649.23 3.968l-1.257 2.944a1.315 1.315 0 0 0 1.07 1.819l8.028.842a1.313 1.313 0 0 0 1.431-1.517c-.42-2.573-1.184-7.206-1.28-7.594L46.538 97.49l.005.006Z"
      fill={colors.cyan10}
    />
    <path
      d="M46.543 97.496H26.94l.128 15.733c.001.237-.025.474-.078.705l-2.285 5.575a1.31 1.31 0 0 0 1.217 1.808l8.09-.022a1.315 1.315 0 0 0 1.303-1.422l-.536-6.29.295-7.613a2.491 2.491 0 0 1 1.799-2.367 2.435 2.435 0 0 1 2.832 1.348l1.369 4.068c.43 1.278.51 2.649.23 3.968l-1.257 2.944a1.315 1.315 0 0 0 1.07 1.819l8.028.842a1.313 1.313 0 0 0 1.391-.92c.06-.193.073-.396.04-.595-.423-2.59-1.188-7.221-1.28-7.596L46.538 97.49l.005.006Z"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m31.546 69.76 2.538 26.08a1.508 1.508 0 0 1-1.502 1.655h-3.616l6.472 1.94a1.508 1.508 0 0 0 1.688-.607l.889-1.333.812 1.217a1.508 1.508 0 0 0 1.849.55l4.124-1.766h-2.401a1.51 1.51 0 0 1-1.5-1.361l-2.627-26.887c-1.503.227-3.02.343-4.54.347h-.076c-.706.002-1.412.057-2.11.165Z"
      fill={colors.white}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m36.507 80.152 1.448-10.858a.301.301 0 0 1-.345-.298l.007-4.48h-6.663v5.014c.168.03.28.062.28.062l5.273 10.56Z"
      fill={colors.white}
      stroke={colors.purple100}
      strokeWidth="1.292"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M40.61 68.796c-.771.193-1.551.343-2.338.452L40.95 96.66c.053.552.208 1.089.457 1.584l2.154 4.311a1.51 1.51 0 0 0 1.563.818l2.304-.329a1.51 1.51 0 0 0 1.188-2.048l-2.07-5.178a4.485 4.485 0 0 1-.298-1.204l-1.96-18.533a2.395 2.395 0 0 1 .06-.59c9.944-4.095 11.743-17.085 12.068-21.412a1.31 1.31 0 0 0-1.286-1.408l-4.932-.08a1.309 1.309 0 0 0-1.326 1.198c-.297 3.427-1.717 13.012-8.263 15.007Z"
      fill={colors.cyan20}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M40.61 68.796c-.771.193-1.551.343-2.338.452L40.95 96.66c.053.552.208 1.089.457 1.584l2.154 4.311a1.51 1.51 0 0 0 1.563.818l2.304-.329a1.51 1.51 0 0 0 1.188-2.048l-2.07-5.178a4.485 4.485 0 0 1-.298-1.204l-1.96-18.533a2.395 2.395 0 0 1 .06-.59c9.944-4.095 11.743-17.085 12.068-21.412a1.31 1.31 0 0 0-1.286-1.408l-4.932-.08a1.309 1.309 0 0 0-1.326 1.198c-.297 3.427-1.717 13.012-8.263 15.007Z"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.874 89.428a.656.656 0 0 0 .663.67l5.612-.067a1.314 1.314 0 0 0 1.296-1.22 10.79 10.79 0 0 1 5.831-9.096l2.49 16.583a4.517 4.517 0 0 1-.264 2.325l-2.005 5.108a1.51 1.51 0 0 0 1.408 2.06h4.271a1.506 1.506 0 0 0 1.417-.994l2.304-6.338c.232-.634.32-1.311.256-1.983l-2.6-26.79c-9.793.83-20.417 7.348-20.68 19.742Z"
      fill={colors.cyan20}
    />
    <path
      d="M10.874 89.428a.656.656 0 0 0 .663.67l5.615-.068a1.31 1.31 0 0 0 1.293-1.217 10.792 10.792 0 0 1 5.831-9.098l2.49 16.583a4.517 4.517 0 0 1-.264 2.325l-2.005 5.108a1.51 1.51 0 0 0 1.408 2.06h4.271a1.506 1.506 0 0 0 1.417-.994l2.304-6.338c.232-.634.32-1.311.256-1.983l-2.6-26.79c-9.793.83-20.417 7.348-20.68 19.742Z"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m36.507 80.152 3.813-6.791 1.792-.475a.752.752 0 0 0 .355-1.248c-1.05-1.114-2.914-2.816-4.455-2.796l-1.505 11.31ZM36.507 80.152l-5.275-10.556a4.62 4.62 0 0 0-4.523 1.508v3.41a.752.752 0 0 0 1.034.7l2.735-1.094 6.029 6.032Z"
      fill={colors.white}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m36.507 80.152 1.508 17.344"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M50.14 50.304c-.025-.475.08-.948.302-1.368l-.354-3.441a1.508 1.508 0 0 1 3-.31l.246 2.381a2.654 2.654 0 0 1 2.085 2.432c.04.89.015 1.782-.076 2.669l-5.308-.091c.09-.754.125-1.513.105-2.272ZM11.924 93.167a2.628 2.628 0 0 0 2.61 2.489h.196a2.665 2.665 0 0 0 2.473-2.79c-.025-.949.031-1.897.166-2.836l-5.323.061a22.698 22.698 0 0 0-.122 3.076ZM44.25 59.299a1.86 1.86 0 0 0-1.508-1.81v-1.207a9.048 9.048 0 1 0-18.097 0v1.207a1.847 1.847 0 0 0 .187 3.657 9.05 9.05 0 0 0 17.718 0 1.868 1.868 0 0 0 1.7-1.847Z"
      fill={colors.white}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44.25 59.299a1.86 1.86 0 0 0-1.508-1.81v-1.207a9.048 9.048 0 1 0-18.097 0v1.207a1.847 1.847 0 0 0 .187 3.657 9.05 9.05 0 0 0 17.718 0 1.868 1.868 0 0 0 1.7-1.847v0Z"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29.169 57.413a1.131 1.131 0 1 0 2.263 0 1.131 1.131 0 0 0-2.263 0ZM35.955 57.413a1.131 1.131 0 1 0 2.263 0 1.131 1.131 0 0 0-2.263 0Z"
      fill={colors.purple100}
    />
    <path
      d="M27.66 60.429a1.13 1.13 0 1 0 2.262 0 1.13 1.13 0 0 0-2.261 0ZM37.463 60.429a1.131 1.131 0 1 0 2.263 0 1.131 1.131 0 0 0-2.263 0Z"
      fill={colors.cyan20}
    />
    <path
      d="M31.432 63.137a4.074 4.074 0 0 0 4.523 0"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44.25 51.003a6.033 6.033 0 0 0-6.033-6.032h-6.784a1.508 1.508 0 0 1-1.51-1.509h-2.262a4.526 4.526 0 0 0-.496 9.018 4.137 4.137 0 0 0 3.511 3.044h2.02a.15.15 0 0 0 .06-.29 3.255 3.255 0 0 1-1.973-2.726h7.434l4.305 4.303c.14.142.332.22.532.22h.442a.754.754 0 0 0 .754-.753v-5.275Z"
      fill={colors.purple10}
    />
    <path
      d="M44.25 51.003a6.033 6.033 0 0 0-6.033-6.032h-6.784a1.508 1.508 0 0 1-1.51-1.509h-2.262a4.526 4.526 0 0 0-.496 9.018 4.137 4.137 0 0 0 3.511 3.044h2.02a.15.15 0 0 0 .06-.29 3.255 3.255 0 0 1-1.973-2.726h7.434l4.305 4.303c.14.142.332.22.532.22h.442a.754.754 0 0 0 .754-.753v-5.275Z"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m27.85 53.83-2.985 2.985a.754.754 0 0 1-.532.22h-.443a.754.754 0 0 1-.754-.753v-5.28a5.935 5.935 0 0 1 .236-1.574 4.527 4.527 0 0 0 3.793 3.052c.164.48.395.934.685 1.35Z"
      fill={colors.purple10}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M81.169 125.393c0 .521 1.381 1.022 3.84 1.391 2.46.369 5.795.576 9.273.576 3.478 0 6.814-.207 9.273-.576 2.459-.369 3.841-.87 3.841-1.391 0-.522-1.382-1.023-3.841-1.391-2.459-.369-5.795-.577-9.273-.577-3.478 0-6.813.208-9.272.577-2.46.368-3.841.869-3.841 1.391Z"
      fill={colors.grey15}
    />
    <path
      d="m89.522 119.808-.562-4.585a15.927 15.927 0 0 1 .356-5.832l1.163-4.656h-6.375l-.768 5.12a15.94 15.94 0 0 0 .014 4.828l.8 5.12 5.372.005ZM108.566 111.793l-4.523-2.079a15.967 15.967 0 0 1-4.224-2.83 2.136 2.136 0 0 1-.678-1.563v-.586h-6.029a8.247 8.247 0 0 0 2.86 6.241l.828.716a15.955 15.955 0 0 0 4.664 2.799l4.535 1.756 2.567-4.454Z"
      fill={colors.white}
    />
    <path
      d="m108.566 111.793-4.523-2.079a15.967 15.967 0 0 1-4.224-2.83v0a2.136 2.136 0 0 1-.678-1.563v-.586h-6.029a8.247 8.247 0 0 0 2.86 6.241l.828.716a15.955 15.955 0 0 0 4.664 2.799l4.535 1.756 2.567-4.454Z"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M111.933 114.982a1.484 1.484 0 0 0-.72-1.973l-2.647-1.216-2.797 4.864a4.534 4.534 0 0 0 .256 4.917 1.312 1.312 0 0 0 2.198-.112l2.048-3.551 1.662-2.929ZM80.554 124.326a1.314 1.314 0 0 1-1.099-.599 1.31 1.31 0 0 1-.095-1.248 4.524 4.524 0 0 1 4.13-2.671h6.032v3.016a1.508 1.508 0 0 1-1.508 1.508l-7.46-.006Z"
      fill={colors.salmon10}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m89.522 119.808-.562-4.585a15.927 15.927 0 0 1 .356-5.832l1.163-4.656h-6.375l-.768 5.12a15.94 15.94 0 0 0 .014 4.828l.8 5.12 5.372.005Z"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M98.638 89.004a4.608 4.608 0 0 1-.758-3.043l1.024-9.011a1.31 1.31 0 0 1 2.304-.695 6.972 6.972 0 0 1 1.506 6.016l-.977 5.611a1.507 1.507 0 0 0 1.486 1.767h4.707a1.505 1.505 0 0 0 1.484-1.767l-1.109-6.382a8.09 8.09 0 0 1-.102-1.053 12.456 12.456 0 0 0-12.43-11.904h-6.785a9.685 9.685 0 0 0-8.058 4.312l-2.353 3.532a2.706 2.706 0 0 1-4.626-.205l-1.152-4.608a1.509 1.509 0 0 0-2.123-.991l-4.884 2.377a1.508 1.508 0 0 0-.314 2.509l2.49 2.099a16.407 16.407 0 0 1 2.012 2.16 7.965 7.965 0 0 0 12.6.098l1.743 6.172a4.559 4.559 0 0 1-.305 3.227c-.832 1.719-2.029 3.296-3.02 4.925a54.406 54.406 0 0 0-4.664 9.512c-.256.684-2.711 8.335-2.263 8.435a11.1 11.1 0 0 0 6.748-.283c2.816-1.205 4.621-4.009 7.263-5.551a12.973 12.973 0 0 1 9.204-1.024c2.192.469 4.364 1.295 6.599 1.126a7.55 7.55 0 0 0 3.689-1.296 4.005 4.005 0 0 0 1.369-1.449 15.182 15.182 0 0 1-2.703-3.14 72.404 72.404 0 0 0-4.591-7.7c-1.004-1.26-2.129-2.421-3.01-3.776Z"
      fill={colors.red10}
    />
    <path
      d="M98.638 89.004a4.608 4.608 0 0 1-.758-3.043l1.024-9.011a1.31 1.31 0 0 1 2.304-.695 6.972 6.972 0 0 1 1.506 6.016l-.977 5.611a1.507 1.507 0 0 0 1.486 1.767h4.707a1.505 1.505 0 0 0 1.484-1.767l-1.109-6.382a7.918 7.918 0 0 1-.101-1.053 12.462 12.462 0 0 0-12.432-11.904h-6.784a9.685 9.685 0 0 0-8.058 4.312l-2.353 3.532a2.706 2.706 0 0 1-4.626-.205l-1.152-4.608a1.509 1.509 0 0 0-2.123-.991l-4.884 2.377a1.508 1.508 0 0 0-.314 2.509l2.49 2.099a16.407 16.407 0 0 1 2.012 2.16 7.965 7.965 0 0 0 12.6.098l1.743 6.172a4.559 4.559 0 0 1-.305 3.227c-.832 1.719-2.029 3.296-3.02 4.925a54.406 54.406 0 0 0-4.664 9.512c-.256.684-2.711 8.335-2.263 8.435a11.1 11.1 0 0 0 6.748-.283c2.816-1.205 4.621-4.009 7.263-5.551a12.973 12.973 0 0 1 9.204-1.024c2.192.469 4.364 1.295 6.599 1.126a7.55 7.55 0 0 0 3.689-1.296 4.005 4.005 0 0 0 1.369-1.449 15.182 15.182 0 0 1-2.703-3.14 72.404 72.404 0 0 0-4.591-7.7c-1.004-1.26-2.129-2.421-3.01-3.776Z"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M82.577 79.825a5.666 5.666 0 0 1-.053-3.18"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M69.76 68.41a2.64 2.64 0 1 0-4.635 2.528l1.004 1.858 4.75-2.304-1.12-2.082ZM105.574 94.933a2.64 2.64 0 0 0 2.64-2.645v-2.634h-5.278v2.634a2.644 2.644 0 0 0 2.638 2.645Z"
      fill={colors.white}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m68.4 77.965 5.336-2.637M102.3 84.643l6.552.011"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M95.772 68.541h-.177a1.248 1.248 0 0 1-1.248-1.249V60.11h-5.422v7.265a1.247 1.247 0 0 1-1.098 1.24 9.6 9.6 0 0 0-2.38.6c.383 1.968-.23 4.441-.17 6.373a5.43 5.43 0 0 1 2.962.64c.504.262.977.581 1.408.95a1.312 1.312 0 0 0 1.692 0c.43-.368.9-.686 1.402-.95a5.43 5.43 0 0 1 2.963-.64 13.867 13.867 0 0 1 2.088-6.883 12.607 12.607 0 0 0-2.02-.163Z"
      fill={colors.white}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M107.823 104.556a5.891 5.891 0 0 1-3.683 1.821c-2.331.187-4.597-.735-6.884-1.257a12.757 12.757 0 0 0-9.6 1.143c-2.756 1.72-3.822 4.454-6.77 5.768a7.428 7.428 0 0 1-5.18.841c-3.758.505-4.345 5.161-4.058 5.228 2.6.763 5.38.638 7.903-.354 3.292-1.507 5.409-5.015 8.504-6.945a14.304 14.304 0 0 1 10.776-1.28c2.567.586 5.11 1.62 7.726 1.408a8.506 8.506 0 0 0 4.318-1.617 7.347 7.347 0 0 0 2.021-2.196 5.174 5.174 0 0 0-5.073-2.56Z"
      fill={colors.purple10}
    />
    <path
      d="M107.823 104.556a5.891 5.891 0 0 1-3.683 1.821c-2.331.187-4.597-.735-6.884-1.257a12.757 12.757 0 0 0-9.6 1.143c-2.756 1.72-3.822 4.454-6.77 5.768a7.428 7.428 0 0 1-5.18.841c-3.758.505-4.345 5.161-4.058 5.228 2.6.763 5.38.638 7.903-.354 3.292-1.507 5.409-5.015 8.504-6.945a14.304 14.304 0 0 1 10.776-1.28c2.567.586 5.11 1.62 7.726 1.408a8.506 8.506 0 0 0 4.318-1.617 7.347 7.347 0 0 0 2.021-2.196 5.174 5.174 0 0 0-5.073-2.56v0Z"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M106.344 101.276a5.647 5.647 0 0 1-3.533 1.747c-2.238.18-4.41-.705-6.604-1.205a12.233 12.233 0 0 0-9.216 1.095c-2.64 1.65-3.663 4.274-6.487 5.532a7.118 7.118 0 0 1-4.967.807c-3.608.485-4.17 4.951-3.894 5.016 2.494.732 5.161.612 7.58-.34 3.158-1.445 5.19-4.809 8.156-6.656a13.73 13.73 0 0 1 10.337-1.232c2.462.563 4.9 1.555 7.41 1.353a8.15 8.15 0 0 0 4.145-1.556 7.06 7.06 0 0 0 1.937-2.099 4.959 4.959 0 0 0-4.864-2.462Z"
      fill={colors.purple10}
    />
    <path
      d="M106.344 101.276a5.647 5.647 0 0 1-3.533 1.747c-2.238.18-4.41-.705-6.604-1.205a12.233 12.233 0 0 0-9.216 1.095c-2.64 1.65-3.663 4.274-6.487 5.532a7.118 7.118 0 0 1-4.967.807c-3.608.485-4.17 4.951-3.894 5.016 2.494.732 5.161.612 7.58-.34 3.158-1.445 5.19-4.809 8.156-6.656a13.73 13.73 0 0 1 10.337-1.232c2.462.563 4.9 1.555 7.41 1.353a8.15 8.15 0 0 0 4.145-1.556 7.06 7.06 0 0 0 1.937-2.099 4.959 4.959 0 0 0-4.864-2.462Z"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M104.832 97.92a5.287 5.287 0 0 1-3.304 1.633c-2.091.168-4.124-.659-6.174-1.127a11.442 11.442 0 0 0-8.614 1.024c-2.472 1.542-3.427 3.996-6.072 5.173a6.652 6.652 0 0 1-4.645.754c-3.373.453-3.899 4.63-3.642 4.691a10.96 10.96 0 0 0 7.089-.318c2.954-1.352 4.853-4.498 7.628-6.23a12.838 12.838 0 0 1 9.666-1.152c2.304.526 4.584 1.454 6.93 1.265a7.636 7.636 0 0 0 3.876-1.456 6.586 6.586 0 0 0 1.806-1.966 4.638 4.638 0 0 0-4.544-2.291Z"
      fill={colors.purple10}
    />
    <path
      d="M104.832 97.92a5.287 5.287 0 0 1-3.304 1.633c-2.091.168-4.124-.659-6.174-1.127a11.442 11.442 0 0 0-8.614 1.024c-2.472 1.542-3.427 3.996-6.072 5.173a6.652 6.652 0 0 1-4.645.754c-3.373.453-3.899 4.63-3.642 4.691a10.96 10.96 0 0 0 7.089-.318c2.954-1.352 4.853-4.498 7.628-6.23a12.838 12.838 0 0 1 9.666-1.152c2.304.526 4.584 1.454 6.93 1.265a7.636 7.636 0 0 0 3.876-1.456 6.586 6.586 0 0 0 1.806-1.966 4.638 4.638 0 0 0-4.544-2.291Z"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M101.56 58.147a1.876 1.876 0 0 0-1.524-1.827V55.1a9.15 9.15 0 0 0-9.147-9.038 9.147 9.147 0 0 0-9.146 9.038v1.22a1.867 1.867 0 0 0 .192 3.697 9.147 9.147 0 0 0 17.909 0 1.887 1.887 0 0 0 1.716-1.87Z"
      fill={colors.white}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M84.792 59.29a1.143 1.143 0 1 0 2.287 0 1.143 1.143 0 0 0-2.287 0ZM94.7 59.29a1.143 1.143 0 1 0 2.287 0 1.143 1.143 0 0 0-2.286 0Z"
      fill={colors.red10}
    />
    <path
      d="M95.01 56.622a1.297 1.297 0 0 0-1.834 0M86.769 56.622a1.296 1.296 0 0 1 1.834 0M93.176 61.952a3.814 3.814 0 0 1-4.573 0M97.437 41.217l-1.737 1.29"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M101.535 40.192a2.29 2.29 0 0 1-3.03 1.819 2.285 2.285 0 1 1 3.03-1.819Z"
      fill={colors.red10}
    />
    <path
      d="M101.535 40.192a2.29 2.29 0 0 1-3.03 1.819 2.285 2.285 0 1 1 3.03-1.819v0Z"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M85.554 44.818a5.335 5.335 0 1 0 10.67 0 5.335 5.335 0 0 0-10.67 0Z"
      fill={colors.mustard10}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M90.127 43.665c-6.74 0-9.308 5.365-9.812 9.77a1.515 1.515 0 0 0 1.522 1.664h18.105a1.514 1.514 0 0 0 1.521-1.664c-.503-4.405-3.072-9.77-9.811-9.77h-1.525Z"
      fill={colors.mustard10}
    />
    <path
      d="M84.792 55.095v-3.808M88.603 55.095v-3.808M93.176 55.095v-3.808M96.987 55.095v-3.808M90.127 43.665c-6.74 0-9.308 5.365-9.812 9.77a1.515 1.515 0 0 0 1.522 1.664h18.105a1.514 1.514 0 0 0 1.521-1.664c-.503-4.405-3.072-9.77-9.811-9.77h-1.525ZM51.013 30.116a20.694 20.694 0 0 1 5.092-1.363M56.105 34.405a20.64 20.64 0 0 1-5.092-1.363"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M50.941 31.579a15.777 15.777 0 0 0 26.936 11.157 15.78 15.78 0 1 0-26.936-11.157Z"
      fill={colors.white}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M82.432 33.042A15.792 15.792 0 0 1 72.2 46.381a15.505 15.505 0 0 0 3.642-5.677 24.12 24.12 0 0 0 1.493-6.296 20.645 20.645 0 0 0 5.097-1.366Z"
      fill={colors.cyan10}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M51.013 33.042a20.64 20.64 0 0 0 5.092 1.363 24.12 24.12 0 0 0 1.495 6.3 15.506 15.506 0 0 0 3.643 5.68 15.793 15.793 0 0 1-10.235-13.343"
      fill={colors.cyan10}
    />
    <path
      d="M51.013 33.042a20.64 20.64 0 0 0 5.092 1.363 24.12 24.12 0 0 0 1.495 6.3 15.506 15.506 0 0 0 3.643 5.68v0a15.793 15.793 0 0 1-10.235-13.343"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M65.25 15.872a21.095 21.095 0 0 0-1.356 5.092 62.604 62.604 0 0 0-.689 7.1 62.604 62.604 0 0 0-7.1.689c-1.748.235-3.46.693-5.092 1.363l-.069 1.463A15.779 15.779 0 0 1 66.72 15.8"
      fill={colors.cyan10}
    />
    <path
      d="M65.25 15.872a21.095 21.095 0 0 0-1.356 5.092 62.604 62.604 0 0 0-.689 7.1 62.604 62.604 0 0 0-7.1.689c-1.748.235-3.46.693-5.092 1.363l-.069 1.463A15.779 15.779 0 0 1 66.72 15.8"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M63.894 20.964a24.122 24.122 0 0 0-6.294 1.492 15.514 15.514 0 0 1 3.643-5.68 15.53 15.53 0 0 1 4.009-.904h.008a14.963 14.963 0 0 1 2.926 0h.007a15.53 15.53 0 0 1 4.01.904 15.514 15.514 0 0 1 3.642 5.68 24.12 24.12 0 0 0-6.296-1.492 27.937 27.937 0 0 0-5.653 0h-.002ZM69.546 42.194a21.036 21.036 0 0 1-1.355 5.092h-.008c-.973.095-1.953.095-2.926 0h-.008a21.091 21.091 0 0 1-1.355-5.092c1.879.191 3.773.191 5.652 0Z"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M63.894 20.964a62.58 62.58 0 0 0-.689 7.1 62.581 62.581 0 0 0-7.1.689 24.119 24.119 0 0 1 1.495-6.297 24.119 24.119 0 0 1 6.294-1.492Z"
      fill={colors.cyan10}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M70.235 28.064a93.916 93.916 0 0 0-3.515-.072c-1.21 0-2.38.03-3.515.072.095-2.378.324-4.748.689-7.1a27.937 27.937 0 0 1 5.652 0 62.28 62.28 0 0 1 .689 7.1Z"
      fill={colors.cyan10}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M77.335 28.753a62.58 62.58 0 0 0-7.1-.689 62.326 62.326 0 0 0-.689-7.1 24.12 24.12 0 0 1 6.297 1.492 24.125 24.125 0 0 1 1.492 6.297ZM63.894 42.194a24.12 24.12 0 0 1-6.294-1.49 24.124 24.124 0 0 1-1.492-6.296c2.351.365 4.722.595 7.1.688.093 2.377.322 4.747.686 7.098Z"
      fill={colors.cyan10}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M70.235 35.094a62.28 62.28 0 0 1-.689 7.1c-1.88.191-3.773.191-5.652 0a62.604 62.604 0 0 1-.689-7.1 94.14 94.14 0 0 0 3.515.071c1.21 0 2.38-.029 3.515-.071Z"
      fill={colors.cyan10}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M77.335 34.405a24.122 24.122 0 0 1-1.492 6.299 24.117 24.117 0 0 1-6.297 1.492c.365-2.351.595-4.722.689-7.1a62.33 62.33 0 0 0 7.1-.69Z"
      fill={colors.cyan10}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M63.133 31.579c0 1.204.03 2.38.072 3.515a62.302 62.302 0 0 1-7.1-.689 27.937 27.937 0 0 1 0-5.652 62.604 62.604 0 0 1 7.1-.689 94.2 94.2 0 0 0-.072 3.515Z"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M70.306 31.579c0 1.204-.029 2.38-.071 3.515a94.14 94.14 0 0 1-3.515.071c-1.21 0-2.38-.029-3.515-.071a94.426 94.426 0 0 1-.072-3.515c0-1.205.03-2.38.072-3.515a93.922 93.922 0 0 1 3.515-.072c1.21 0 2.38.03 3.515.072.037 1.134.072 2.31.072 3.515Z"
      fill={colors.cyan10}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M77.478 31.579c0 .944-.047 1.887-.143 2.826a62.303 62.303 0 0 1-7.1.689c.042-1.134.072-2.31.072-3.515s-.03-2.381-.072-3.515c2.378.094 4.748.324 7.1.689.096.939.143 1.882.143 2.826Z"
      fill={colors.cyan10}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M66.72 15.8V.64M50.941 31.579a15.777 15.777 0 0 0 26.936 11.157 15.78 15.78 0 1 0-26.936-11.157v0Z"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M75.843 22.456a15.552 15.552 0 0 1 5.678 3.64"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M81.523 37.059a15.504 15.504 0 0 1-5.68 3.645l5.68-3.645Z" fill={colors.cyan10} />
    <path
      d="M81.523 37.059a15.504 15.504 0 0 1-5.68 3.645M51.917 26.1a15.516 15.516 0 0 1 5.683-3.644M57.6 40.704a15.516 15.516 0 0 1-5.68-3.643M77.335 28.753c1.75.235 3.463.694 5.097 1.365M82.432 33.042a20.64 20.64 0 0 1-5.092 1.363M61.24 46.382a15.504 15.504 0 0 1-3.64-5.678M75.843 40.704a15.506 15.506 0 0 1-3.643 5.68M68.19 15.872a21.036 21.036 0 0 1 1.356 5.092M63.894 20.964a21.09 21.09 0 0 1 1.355-5.092"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M72.198 16.777a15.833 15.833 0 0 1 9.323 9.318 15.553 15.553 0 0 0-5.678-3.639 15.516 15.516 0 0 0-3.643-5.68"
      fill={colors.cyan10}
    />
    <path
      d="M72.198 16.777a15.833 15.833 0 0 1 9.323 9.318 15.553 15.553 0 0 0-5.678-3.639 15.516 15.516 0 0 0-3.643-5.68"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
